/**
 * phoenix-acc-customizer.js — Phoenix Putter Co, accessory PDP v2 ("E3 photo stage")
 *
 * Drives sections/phoenix-acc-customizer.liquid. Emits the SAME line-item properties as the
 * simple customizer (snippets/phoenix-customizer-simple.liquid) so the "No Customization"
 * Shopify Flow, ShipStation item options and the production sheet are unchanged:
 *   Customization                'Customized — see details below' | 'No Customization Needed'
 *   <side1 label>                text                  (default 'Custom Engraved Text Side #1')
 *   <side1 label> Font           font name
 *   <side1 label> Custom Font    only when 'Other'
 *   <side1 upload label>         Cloudinary URL        (default 'Custom Graphic Upload')
 *   <side2 label>                text                  (default 'Custom Engraved Text Side #2')
 *   <side2 label> Font / Custom Font
 *   <side2 label> Graphic        Cloudinary URL
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pacc]');
  if (!root) return;

  var d = root.dataset;
  var cfg = {
    sides: parseInt(d.sides || '1', 10),
    productTitle: d.productTitle || '',
    currency: d.currency || '$',
    maxChars: parseInt(d.maxChars || '20', 10),
    cloud: d.cloudName,
    preset: d.uploadPreset,
    redirect: d.redirect || 'cart',
    labels: { 1: d.side1Label, 2: d.side2Label },
    uploadLabels: { 1: d.side1UploadLabel, 2: (d.side2Label || '') + ' Graphic' },
    names: { 1: d.side1Name || 'Side 1', 2: d.side2Name || 'Side 2' },
    zones: { 1: parseZone(d.zone1), 2: parseZone(d.zone2) },
    imgs: { 1: d.side1Img, 2: d.side2Img },
    side1Locked: d.side1ImgLocked === 'true'
  };

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-pacc-variants]').textContent); } catch (e) { variants = []; }

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  var state = {
    variant: null,
    selectedOptions: [],
    customization: null,   // 'yes' | 'no' | null
    activeSide: 1,
    qty: 1,
    viewingPhoto: false,   // a gallery thumbnail is showing instead of the live preview
    sides: {}
  };
  for (var i = 1; i <= cfg.sides; i++) state.sides[i] = { mode: 'text', text: '', font: '', customFont: '', graphicUrl: '' };

  var els = {
    stage: $('[data-pacc-stage]'),
    stageImg: $('[data-pacc-stage-img]'),
    live: $('[data-pacc-live]'),
    zones: {},
    flips: $$('[data-pacc-flip]'),
    thumbs: $$('[data-pacc-thumb]'),
    price: $('[data-pacc-price]'),
    compare: $('[data-pacc-compare]'),
    total: $('[data-pacc-total]'),
    choices: $$('[data-pacc-choice]'),
    error: $('[data-pacc-error]'),
    atc: $('[data-pacc-atc]'),
    atcLabel: $('[data-pacc-atc-label]'),
    qtyInput: $('[data-pacc-qty-input]'),
    bar: $('[data-pacc-bar]'),
    barSum: $('[data-pacc-bar-sum]'),
    barPrice: $('[data-pacc-bar-price]'),
    barGo: $('[data-pacc-bar-go]')
  };
  $$('[data-pacc-zone]').forEach(function (z) { els.zones[z.dataset.paccZone] = z; });

  /* ---------- helpers ---------- */
  function parseZone(str) {
    var p = (str || '').split(',').map(function (s) { return s.trim(); });
    var n = function (v, def) { var x = parseFloat(v); return isNaN(x) ? def : x; };
    return { left: n(p[0], 25), top: n(p[1], 38), width: n(p[2], 50), height: n(p[3], 24), rotate: n(p[4], 0), shape: (p[5] || 'rect').toLowerCase() === 'round' ? 'round' : 'rect' };
  }
  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return cfg.currency + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function showError(msg, fieldKey) {
    if (els.error) { els.error.textContent = msg; els.error.hidden = false; }
    $$('[data-pacc-field]').forEach(function (f) { f.classList.remove('pacc-field--invalid'); });
    if (fieldKey) {
      var f = $('[data-pacc-field="' + fieldKey + '"]');
      if (f) { f.classList.add('pacc-field--invalid'); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }
  function clearError() {
    if (els.error) { els.error.hidden = true; els.error.textContent = ''; }
    $$('[data-pacc-field]').forEach(function (f) { f.classList.remove('pacc-field--invalid'); });
  }
  function sideHasContent(i) {
    var s = state.sides[i];
    return (s.mode === 'text' && s.text.trim().length > 0) || (s.mode === 'logo' && !!s.graphicUrl);
  }
  function anyContent() { for (var i = 1; i <= cfg.sides; i++) if (sideHasContent(i)) return true; return false; }

  /* ---------- zones on the stage ---------- */
  function placeZone(i) {
    var z = els.zones[i]; if (!z) return;
    var g = cfg.zones[i];
    z.style.left = g.left + '%'; z.style.top = g.top + '%';
    z.style.width = g.width + '%'; z.style.height = g.height + '%';
    z.style.transform = g.rotate ? 'rotate(' + g.rotate + 'deg)' : '';
    z.classList.toggle('pacc-zone--round', g.shape === 'round');
    z.classList.toggle('pacc-zone--rect', g.shape !== 'round');
  }
  function fitZoneText(i) {
    var z = els.zones[i]; if (!z) return;
    var t = $('[data-pacc-zone-text]', z); if (!t) return;
    var maxH = z.clientHeight * 0.62;
    var maxW = z.clientWidth * 0.9;
    var size = Math.max(10, maxH);
    t.style.fontSize = size + 'px';
    var guard = 0;
    while (t.scrollWidth > maxW && size > 9 && guard++ < 40) { size -= Math.max(1, size * 0.08); t.style.fontSize = size + 'px'; }
  }
  function renderZone(i) {
    var z = els.zones[i]; if (!z) return;
    var s = state.sides[i];
    var t = $('[data-pacc-zone-text]', z);
    var img = $('[data-pacc-zone-img]', z);
    var isLogo = s.mode === 'logo';
    z.classList.toggle('pacc-zone--logo', isLogo && !!s.graphicUrl);
    z.classList.toggle('pacc-zone--empty', !sideHasContent(i));
    if (t) {
      var fam = s.font === 'Other' ? (s.customFont || 'Outfit') : (s.font || 'Outfit');
      t.style.fontFamily = '"' + fam + '", sans-serif';
      t.textContent = isLogo ? '' : (s.text || '');
      fitZoneText(i);
    }
    if (img) { if (isLogo && s.graphicUrl) img.src = s.graphicUrl; else img.removeAttribute('src'); }
  }
  function showSide(i, fromUser) {
    state.activeSide = i;
    state.viewingPhoto = false;
    Object.keys(els.zones).forEach(function (k) { els.zones[k].classList.toggle('pacc-zone--hidden', String(k) !== String(i)); });
    els.flips.forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.dataset.paccFlip, 10) === i)); });
    $$('[data-pacc-side]').forEach(function (p) { p.classList.toggle('pacc-side--on', parseInt(p.dataset.paccSide, 10) === i); });
    setStageImage(stageImageFor(i));
    els.thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.dataset.paccThumb === 'preview')); });
    if (els.live) els.live.style.display = '';
    renderZone(i);
  }
  function stageImageFor(i) {
    if (i === 1 && !cfg.side1Locked && state.variant && state.variant.image) return state.variant.image;
    return cfg.imgs[i] || cfg.imgs[1];
  }
  function setStageImage(src) {
    if (!els.stageImg || !src) return;
    if (els.stageImg.getAttribute('src') !== src) { els.stageImg.removeAttribute('srcset'); els.stageImg.src = src; }
  }

  /* ---------- gallery thumbnails ---------- */
  els.thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var v = t.dataset.paccThumb;
      if (v === 'preview') { showSide(state.activeSide); return; }
      state.viewingPhoto = true;
      setStageImage(v);
      Object.keys(els.zones).forEach(function (k) { els.zones[k].classList.add('pacc-zone--hidden'); });
      if (els.live) els.live.style.display = 'none';
      els.thumbs.forEach(function (x) { x.setAttribute('aria-current', String(x === t)); });
    });
  });
  els.flips.forEach(function (b) { b.addEventListener('click', function () { showSide(parseInt(b.dataset.paccFlip, 10)); }); });

  /* ---------- variants ---------- */
  function initVariant() {
    var pressed = $$('[data-pacc-option]').map(function (g) {
      var on = $('[data-pacc-value][aria-pressed="true"]', g);
      return on ? on.dataset.paccValue : null;
    });
    state.selectedOptions = pressed;
    if (!variants.length) return;
    if (!pressed.length) { state.variant = variants[0]; return; }
    resolveVariant();
  }
  function resolveVariant() {
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < state.selectedOptions.length; j++) if (v.options[j] !== state.selectedOptions[j]) { ok = false; break; }
      if (ok) { match = v; break; }
    }
    state.variant = match;
    // mark unavailable values for the other options
    $$('[data-pacc-option]').forEach(function (g, idx) {
      $$('[data-pacc-value]', g).forEach(function (b) {
        var trial = state.selectedOptions.slice(); trial[idx] = b.dataset.paccValue;
        var exists = variants.some(function (v) { return v.available && trial.every(function (val, k) { return val == null || v.options[k] === val; }); });
        b.dataset.unavailable = exists ? 'false' : 'true';
      });
    });
    updatePrice();
    if (!state.viewingPhoto && state.activeSide === 1) setStageImage(stageImageFor(1));
    if (els.atc) {
      var avail = !!(match && match.available);
      els.atc.disabled = !avail;
      if (els.atcLabel) els.atcLabel.textContent = avail ? 'Add to cart' : (match ? 'Sold out' : 'Unavailable');
    }
    try {
      if (match) { var u = new URL(window.location.href); u.searchParams.set('variant', match.id); history.replaceState(null, '', u.toString()); }
    } catch (e) {}
  }
  $$('[data-pacc-option]').forEach(function (g, idx) {
    $$('[data-pacc-value]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        state.selectedOptions[idx] = b.dataset.paccValue;
        $$('[data-pacc-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        clearError();
        resolveVariant();
      });
    });
  });

  /* ---------- price / qty ---------- */
  function unitPrice() { return state.variant ? state.variant.price : 0; }
  function updatePrice() {
    var p = unitPrice();
    if (els.price) els.price.textContent = money(p);
    if (els.compare) {
      var c = state.variant ? state.variant.compare : 0;
      if (c && c > p) { els.compare.textContent = money(c); els.compare.hidden = false; } else { els.compare.hidden = true; }
    }
    var total = p * state.qty;
    if (els.total) els.total.textContent = money(total);
    if (els.barPrice) els.barPrice.textContent = money(total);
  }
  function setQty(n) {
    n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
    state.qty = n;
    if (els.qtyInput) els.qtyInput.value = n;
    updatePrice();
  }
  $$('[data-pacc-qty]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty + parseInt(b.dataset.paccQty, 10)); }); });
  if (els.qtyInput) els.qtyInput.addEventListener('change', function () { setQty(els.qtyInput.value); });

  /* ---------- clean / engrave ---------- */
  function setCustomization(v) {
    state.customization = v;
    els.choices.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.paccChoice === v)); });
    root.classList.toggle('pacc-cfg--clean', v === 'no');
    if (v === 'yes' && !state.viewingPhoto) showSide(state.activeSide);
    updateBarSummary();
    clearError();
  }
  els.choices.forEach(function (b) { b.addEventListener('click', function () { setCustomization(b.dataset.paccChoice); }); });

  /* ---------- per-side panels ---------- */
  $$('[data-pacc-side]').forEach(function (panel) {
    var i = parseInt(panel.dataset.paccSide, 10);
    var s = state.sides[i];
    var count = $('[data-pacc-count]', panel);
    var dot = $('[data-pacc-dot]', panel);
    var textInput = $('[data-pacc-text]', panel);
    var fontSelect = $('[data-pacc-font]', panel);
    var fontTiles = $('[data-pacc-fonts]', panel);
    var customFont = $('[data-pacc-custom-font]', panel);
    var modeBtns = $$('[data-pacc-mode]', panel);
    var modePanels = $$('[data-pacc-mode-panel]', panel);
    var upload = $('[data-pacc-upload]', panel);
    var file = $('[data-pacc-file]', panel);
    var uploaded = $('[data-pacc-uploaded]', panel);
    var uploadedImg = $('[data-pacc-uploaded-img]', panel);
    var remove = $('[data-pacc-remove]', panel);

    // Font tiles from the shared <select> (single source of truth): first 3 + More…
    if (fontSelect && fontTiles) {
      var opts = Array.prototype.slice.call(fontSelect.options).filter(function (o) { return o.value && o.value !== 'Other'; });
      s.font = fontSelect.value || (opts[0] && opts[0].value) || 'Outfit';
      opts.slice(0, 3).forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pacc-font'; b.textContent = o.value;
        b.style.fontFamily = '"' + o.value + '", sans-serif'; b.dataset.font = o.value;
        b.setAttribute('aria-pressed', String(o.value === s.font));
        b.addEventListener('click', function () { setFont(o.value); });
        fontTiles.appendChild(b);
      });
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'pacc-font'; more.textContent = 'More…';
      more.style.color = '#6B7075'; more.style.fontSize = '13px';
      more.addEventListener('click', function () { fontSelect.hidden = false; fontSelect.focus(); });
      fontTiles.appendChild(more);
      fontSelect.addEventListener('change', function () { setFont(fontSelect.value, true); });
      if (customFont) customFont.addEventListener('input', function () { s.customFont = customFont.value; render(); });
    }
    function setFont(name, fromSelect) {
      s.font = name;
      if (fontSelect && fontSelect.value !== name) fontSelect.value = name;
      $$('.pacc-font[data-font]', fontTiles).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.font === name)); });
      if (customFont) customFont.hidden = name !== 'Other';
      if (!fromSelect && fontSelect) fontSelect.hidden = true;
      render();
    }
    function activate() {
      if (!state.customization) setCustomization('yes');
      if (state.activeSide !== i || state.viewingPhoto) showSide(i);
    }
    function render() {
      if (count) count.textContent = (s.mode === 'text' ? s.text.length : 0) + ' / ' + cfg.maxChars;
      if (dot) dot.classList.toggle('pacc-dot--off', i !== 1 && !sideHasContent(i));
      renderZone(i);
      updateBarSummary();
    }
    panel.addEventListener('focusin', function () { if (state.customization !== 'no') { if (state.activeSide !== i || state.viewingPhoto) showSide(i); } });
    if (textInput) {
      textInput.addEventListener('input', function () {
        s.text = textInput.value;
        if (s.text.trim()) activate();
        render();
      });
    }
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        s.mode = b.dataset.paccMode;
        modeBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        modePanels.forEach(function (p) { p.hidden = p.dataset.paccModePanel !== s.mode; });
        activate();
        render();
      });
    });
    function setUploaded(url) {
      s.graphicUrl = url || '';
      if (uploaded) uploaded.style.display = url ? 'flex' : 'none';
      if (uploadedImg) { if (url) uploadedImg.src = url; else uploadedImg.removeAttribute('src'); }
      if (upload) upload.style.display = url ? 'none' : '';
      if (url) activate();
      render();
    }
    if (file) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (!f) return;
        if (f.size > 5 * 1024 * 1024) { showError('That file is over 5 MB — please use a smaller image.'); file.value = ''; return; }
        clearError();
        if (upload) upload.classList.add('pacc-upload--busy');
        uploadToCloudinary(f).then(setUploaded).catch(function (err) {
          console.error('[pacc] upload failed', err);
          showError('Logo upload failed. Please try again, or add to cart with text and email us the file.');
        }).then(function () { if (upload) upload.classList.remove('pacc-upload--busy'); file.value = ''; });
      });
    }
    if (remove) remove.addEventListener('click', function () { setUploaded(''); });
    render();
  });

  function uploadToCloudinary(f) {
    var fd = new FormData();
    fd.append('file', f);
    fd.append('upload_preset', cfg.preset);
    fd.append('folder', 'phoenix-orders');
    return fetch('https://api.cloudinary.com/v1_1/' + cfg.cloud + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
      .then(function (data) { return data.secure_url; });
  }

  /* ---------- sticky bar ---------- */
  function updateBarSummary() {
    if (!els.barSum) return;
    var parts = [];
    if (state.variant && state.variant.title && state.variant.title !== 'Default Title') parts.push(state.variant.title);
    if (state.customization === 'no') parts.push('No engraving');
    else if (state.customization === 'yes') {
      for (var i = 1; i <= cfg.sides; i++) {
        var s = state.sides[i];
        if (s.mode === 'logo' && s.graphicUrl) parts.push(cfg.names[i] + ': logo');
        else if (s.mode === 'text' && s.text.trim()) parts.push(cfg.names[i] + ' "' + s.text.trim() + '"');
      }
      if (parts.length === (state.variant && state.variant.title !== 'Default Title' ? 1 : 0)) parts.push('Engraved');
    }
    els.barSum.textContent = parts.length ? '· ' + parts.join(' · ') : '';
  }
  if (els.bar && els.atc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0; // card scrolled above the viewport
      var show = !e.isIntersecting && below;
      els.bar.classList.toggle('pacc-bar--show', show);
      els.bar.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0 });
    io.observe(els.atc);
    if (els.barGo) els.barGo.addEventListener('click', function () { els.atc.click(); if (els.atc.disabled) return; });
  }

  /* ---------- add to cart ---------- */
  function buildProperties() {
    var props = { 'Customization': state.customization === 'no' ? 'No Customization Needed' : 'Customized — see details below' };
    if (state.customization === 'no') return props;
    for (var i = 1; i <= cfg.sides; i++) {
      var s = state.sides[i];
      if (!sideHasContent(i)) continue;
      var label = cfg.labels[i];
      if (s.mode === 'text') {
        props[label] = s.text.trim();
        props[label + ' Font'] = s.font;
        if (s.font === 'Other') props[label + ' Custom Font'] = s.customFont || 'Custom Request';
      } else {
        props[cfg.uploadLabels[i]] = s.graphicUrl;
      }
    }
    return props;
  }
  function validate() {
    if (variants.length > 1 && !state.variant) { showError('Choose an option to continue.', 'variant'); return false; }
    if (state.variant && !state.variant.available) { showError('That option is sold out right now.', 'variant'); return false; }
    if (!state.customization) { showError('Tell us whether to engrave it or leave it clean.', 'customization'); return false; }
    if (state.customization === 'yes' && !anyContent()) { showError('Add text or a logo — or choose "Leave it clean".', 'customization'); return false; }
    return true;
  }
  if (els.atc) {
    els.atc.addEventListener('click', function () {
      if (!validate()) { if (els.bar) els.bar.classList.remove('pacc-bar--show'); return; }
      clearError();
      els.atc.disabled = true;
      var og = els.atcLabel ? els.atcLabel.textContent : '';
      if (els.atcLabel) els.atcLabel.textContent = 'Adding…';
      var items = [{ id: state.variant.id, quantity: state.qty, properties: buildProperties() }];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Add to cart failed'); });
        return r.json();
      }).then(function () {
        if (els.atcLabel) els.atcLabel.textContent = '✓ Added to cart';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (cfg.redirect === 'cart') setTimeout(function () { window.location.href = '/cart'; }, 600);
        else setTimeout(function () { els.atc.disabled = false; if (els.atcLabel) els.atcLabel.textContent = og; }, 2500);
      }).catch(function (err) {
        console.error('[pacc] add to cart', err);
        showError(err.message || 'Something went wrong adding this to your cart. Please try again.');
        els.atc.disabled = false;
        if (els.atcLabel) els.atcLabel.textContent = og;
      });
    });
  }

  /* ---------- in-page jumps (IMPACT intercepts a[href^="#"], so these are buttons) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ppdp-scroll]');
    if (!b) return;
    var target = document.querySelector(b.dataset.ppdpScroll);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- init ---------- */
  Object.keys(els.zones).forEach(function (k) { placeZone(parseInt(k, 10)); });
  initVariant();
  updatePrice();
  showSide(1);
  window.addEventListener('resize', function () { Object.keys(els.zones).forEach(function (k) { fitZoneText(parseInt(k, 10)); }); });
  if (els.stageImg) els.stageImg.addEventListener('load', function () { Object.keys(els.zones).forEach(function (k) { fitZoneText(parseInt(k, 10)); }); });
})();
